// Das darf man nicht löschen, sonst gibt es Probleme den Monitoren
import 'core-js';

// TODO-MMUEJDE: Das kann weg, wenn framer motion weg ist
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import './index.css';
import './styles/animations.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
